module.exports = __webpack_public_path__ + "static/harry-potter-and-the-prisoner-of-azkaban-e0229ef92bdd4ce866271d36546dfa80.jpg";